export default {
  safetyUrl: process.env.VUE_APP_SAFETY_URL,
  checkoutApiUrl: process.env.VUE_APP_CHECKOUT_API_URL,
  sentryDsn: process.env.VUE_APP_SENTRY_DSN,
  currentEnvironment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
  realtimeHubUrl: process.env.VUE_APP_REALTIME_HUB_URL,
  mixPanelToken: process.env.VUE_APP_MIXPANEL_PROJECT_TOKEN,
};
